import React, { useState } from "react";
import { Modal } from "react-bootstrap";
const YoutubeVideoPlayer = ({ isOpen, toggle, videoUrl }) => {
  const [loaded, setLoaded] = useState(false);

  const frameLoad = () => {
    setLoaded((prevState) => !prevState);
  };
  return (
    <Modal
      show={isOpen}
      size="xl"
      centered
      // modalClassName="dashboard-video-popup"
      className="modal-dialog-centered"
    >
      <div className="modal-header d-flex align-items-center justify-content-between p-3">
        <h5 className="modal-title FS16FW500">PTE Tutorial Videos</h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        ></button>
      </div>
      <Modal.Body className="d-flex align-items-center justify-content-center flex-column">
        <iframe
          className="dashboard-popup-video"
          allow="fullscreen"
          src={videoUrl}
          title="YouTube Live video player"
          frameBorder="0"
          onLoad={frameLoad}
          style={{
            width: 'clamp(400px, 70vw, 100%)',
            height: 'clamp(120px, 40vw, 500px)',
          }}
        ></iframe>
        {!loaded && (
          <div className="text-center">
            {/* <Spinner/> */}
            <p className="FS14FW600">Loading...</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default YoutubeVideoPlayer;
